import { contractApi, currencyApi, projectApi } from '@atheneum/api'
import find from 'lodash/find'
import get from 'lodash/get'
import { BigNumber } from 'bignumber.js'

import { extendObservable } from 'mobx'

class ContractAssignStore {
  constructor () {
    extendObservable(this, {
      applicableContracts: [],
      ready: false
    })
  }

  init = async fees => {
    this.ready = false
    if (fees) {
      await this.loadApplicableContracts(fees[0].projectId)
    }
    this.ready = true
    return Promise.resolve()
  }

  async loadApplicableContracts (projectId) {
    const applicableContracts = await projectApi.getApplicableContracts(
      projectId
    )
    this.applicableContracts.replace(applicableContracts)
  }

  recalculateFees = async (fees, contract) => {
    return Promise.all(
      fees.map(async feeData => {
        const fee = feeData.fee
        const isFeePAYG = get(fee, 'contract.contractTypeId', null) === 1
        const isContractPAYG = get(contract, 'contractTypeId', null) === 1
        feeData.contractId = contract.id

        const feeItem = find(fee.feeItems, feeItem =>
          Boolean(feeItem.feeTypeId)
        )

        if (!contract.id) {
          return {
            feeValue: 0,
            currencyId: 0,
            credits: 0,
            PAYG: null
          }
        } else if (isFeePAYG && isContractPAYG) {
          return convertPAYGtoPAYG(feeData, feeItem, contract)
        } else if (isFeePAYG && !isContractPAYG) {
          return convertPAYGtoNonPAYG(feeData, feeItem, contract)
        } else if (!isFeePAYG && isContractPAYG) {
          return convertNonPAYGtoPAYG(feeData, feeItem, contract)
        } else if (!isFeePAYG && !isContractPAYG) {
          return convertNonPAYGtoNonPAYG(feeData, feeItem, contract)
        }
      })
    )
  }

  assignFees = async values => {
    const fees = values.fees.map(fee => ({
      value: fee.feeValue,
      credits: fee.credits,
      currencyId: fee.currencyId,
      id: fee.id
    }))
    return contractApi.assignFees({ contractId: values.contract.id, fees })
  }
}

async function convertPAYGtoPAYG (feeData, feeItem, contract) {
  return {
    feeValue: feeItem.value || 0,
    currencyId: feeItem.currencyId || 1,
    credits: 0,
    PAYG: true
  }
}

async function convertPAYGtoNonPAYG (feeData, feeItem, contract) {
  const conversionRate = new BigNumber(
    await currencyApi.getConversionRate(
      feeData.fee.deliveryDate,
      feeItem.currencyId,
      contract.currencyId
    )
  )

  const creditValue = new BigNumber(contract.creditValue)

  return {
    feeValue: BigNumber(feeItem.value || 0)
      .times(conversionRate)
      .precision(2)
      .toNumber(),
    currencyId: contract.currencyId,
    credits: BigNumber(feeItem.value)
      .times(conversionRate)
      .div(creditValue)
      .precision(2)
      .toNumber(),
    PAYG: false
  }
}

async function convertNonPAYGtoNonPAYG (feeData, feeItem, contract) {
  const conversionRate = new BigNumber(
    await currencyApi.getConversionRate(
      feeData.fee.deliveryDate,
      feeItem.currencyId,
      contract.currencyId
    )
  )

  const creditValue = new BigNumber(contract.creditValue)

  return {
    feeValue: BigNumber(feeItem.value || 0)
      .times(conversionRate)
      .precision(2)
      .toNumber(),
    currencyId: contract.currencyId,
    credits: BigNumber(feeItem.value)
      .times(conversionRate)
      .div(creditValue)
      .precision(2)
      .toNumber(),
    PAYG: false
  }
}

async function convertNonPAYGtoPAYG (feeData, feeItem, contract) {
  return {
    feeValue: feeItem.value,
    currencyId: feeItem.currencyId,
    credits: 0,
    PAYG: true
  }
}

export default ContractAssignStore
